import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { Hero }         from '../hero';
import { ProviderportalService } from '../providerportal.service';
import { Modal } from 'bootstrap';


@Component({
    selector: 'app-claimsummarydetail',
    templateUrl: './claimsummarydetail.component.html',
    styleUrls: ['./claimsummarydetail.component.css'],
    standalone: false
})
export class ClaimsummarydetailComponent implements OnInit {

  hero: Hero;
  loading:boolean = false;
  data = [];
  cpt: any;
  dos: any;
  copay: number;
  payAmount: number;
  claimId: number;
  status: any;
  capitationCode: any;
  capitationDescription: any;
  checkNumber: number;
  checkDate: any;
  billed: number;
  withhold: number;
  denied: number;
  disallowExDesc: any;
  cptCode: any;
  servicingProvider: any;
  indivClaim: any;
  eachClaim = [];
  list = [];
  providerClaimDetailsData = [];
  totalBilled: number;
  totalCopay: number;
  memberId: number;
  memberName: any;
  totalPayAmount: number;
  dateOfServiceFrom: any;
  p: number = 1;
  patientAccountNumber: any;
  handleResults(searchObj) {
      this.data = searchObj;
  }
  constructor(
    private route: ActivatedRoute,
    private providerPortalService: ProviderportalService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.claimId = this.route.snapshot.params['claimNo'];
    this.getFullClaimDetails(this.claimId);
  }

  getFullClaimDetails(claimNo): void {
    this.loading = true;
    this.providerPortalService.getClaimDetails(claimNo)
    .subscribe((data) => { 
      this.data = data; 
      const claimDetails = data.responseDatasArray;
      this.servicingProvider = claimDetails[0].claims[0].provider.servicingProvider;
      this.totalBilled = claimDetails[0].claims[0].total.billed;
      this.totalCopay =  claimDetails[0].claims[0].total.copay;
      this.totalPayAmount =  claimDetails[0].claims[0].total.payAmount;
      this.patientAccountNumber = claimDetails[0].patientAccountNumber;
      this.memberId = claimDetails[0].memberId;
      this.memberName = claimDetails[0].memberFirstName + ' ' + claimDetails[0].memberLastName;
      if (claimDetails && claimDetails.length > 0) {
        this.cptCode = claimDetails[0].claims[0].serviceLine[0].procedure[0].procedureCode + ' ' + claimDetails[0].claims[0].serviceLine[0].procedure[0].procedureDesc;
        claimDetails[0].claims[0].serviceLine.forEach(element => { 
          this.eachClaim = claimDetails[0].claims[0].serviceLine;
        });
        this.list.push(this.eachClaim);
        this.loading = false;
      }
    });
  }
  public convertDateFormat(str) {
    try {
      if (str) {
        var month = str.slice(5, 7);
        var date = str.slice(8, 10);
        var year = str.slice(0, 4);
        var totalDate = month + '/' + date + '/' + year;
        return totalDate;
      } else {
        return '';
      }
    } catch (err) {
      throw err;
    }
  }
  showClaimModal(claim) {
    this.indivClaim = claim;
    this.dateOfServiceFrom = this.indivClaim.dateOfServiceFrom;
    this.withhold = this.indivClaim.withhold;
    this.denied = this.indivClaim.denied;
    this.disallowExDesc = this.indivClaim.disallowExDesc;
    this.cptCode = claim.procedure[0].procedureCode + ' ' +  claim.procedure[0].procedureDesc;
   
    this.openModal('claimDetailsModalId');
  }
  modalClose() {
    this.closeModal('claimDetailsModalId');
  }

 goBack(): void {
    this.location.back();
  }

  openModal(modalId: string) {
              const modal = new Modal(document.getElementById(modalId));
              modal.show();
          }
          
          closeModal(modalId: string) {
            const modalElement = document.getElementById(modalId);
              const  modal = Modal.getInstance(modalElement);
              if(modal!=null){
                modal.hide();
              }
          }

}
